var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_107_304)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7303 13.5523C27.881 13.0983 27.7303 12.7681 27.0628 12.7681H24.8448C24.285 12.7681 24.0266 13.057 23.8758 13.3666C23.8758 13.3666 22.7346 16.008 21.1411 17.7208C20.6243 18.216 20.3874 18.3811 20.1075 18.3811C19.9568 18.3811 19.763 18.216 19.763 17.7621V13.5317C19.763 12.9951 19.5907 12.7475 19.117 12.7475H15.6286C15.284 12.7475 15.0687 12.9951 15.0687 13.2427C15.0687 13.7586 15.8654 13.8825 15.9516 15.327V18.4637C15.9516 19.1447 15.8224 19.2685 15.5424 19.2685C14.7888 19.2685 12.9584 16.6064 11.8603 13.5729C11.6449 12.9745 11.4296 12.7475 10.8697 12.7475H8.63025C7.98425 12.7475 7.87659 13.0364 7.87659 13.3459C7.87659 13.9031 8.63025 16.7096 11.3865 20.4241C13.2169 22.9623 15.8224 24.3243 18.1695 24.3243C19.5907 24.3243 19.763 24.0148 19.763 23.4989V21.5797C19.763 20.9607 19.8922 20.8575 20.3444 20.8575C20.6674 20.8575 21.2488 21.0226 22.5623 22.2401C24.0696 23.6846 24.328 24.345 25.1678 24.345H27.3858C28.0318 24.345 28.3332 24.0354 28.161 23.437C27.9672 22.8385 27.235 21.9718 26.2876 20.94C25.7708 20.3622 24.9956 19.7225 24.7587 19.4129C24.4357 19.0002 24.5218 18.8351 24.7587 18.4637C24.7372 18.4637 27.4504 14.7905 27.7303 13.5523Z",
    fill: "#F3F3F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_304",
    x1: 17.9722,
    y1: -0.0557413,
    x2: 17.9722,
    y2: 36.3408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.2b6bf8c4c215acd6bfc7082f40eb112b.svg";
export { ForwardRef as ReactComponent };